Ext.define('SA.view.menu.CreateRadiusLocation', {
    alias: 'widget.menu-create-radius-location',
    extend: 'Ext.menu.Item',

    bubbleEvents: ['create:radiusLocation'],
    text: 'Create Radius Location',

    beforeMenuShow() {
        this.refresh();
    },

    getLocation() {
        return this.location;
    },

    handler() {
        var modal = Ext.widget({
            xtype: 'create-radius-location',
            autoShow: true,

            callback: radiusLocation => {
                this.fireEvent('create:radiusLocation', radiusLocation);
            }
        });

        modal.setLocation(this.getLocation());
    },

    refresh() {
        var locationId = this.getLocation(),
            isCustom = SA.data.LocationsCache.isCustomLocation(locationId),
            location = SA.data.LocationsCache.get(locationId),
            visible = !isCustom && SA.data.GeographicUnits.get(location.geographicUnit).maximumRadius > 0;

        this.setVisible(visible);
    }
});